var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('homeSlider'),_c('aboutUsAndRegistration',{staticClass:"my-5"}),_c('listOfStores'),_c('listOfServices'),_c('events'),_c('statistics'),_c('listOfNews'),_c('newStores')],1)}
var staticRenderFns = []

export { render, staticRenderFns }